<template>
    <vs-sidebar click-not-close position-left parent="body" default-index="1" color="primary"
                class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
        <div class="mt-6 flex items-center justify-between px-6">

            <h4>{{ Object.entries(this.data).length < 2 ? 'Add New Address' : 'Update Address' }} </h4>
            <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
        </div>
        <vs-divider class="mb-0"></vs-divider>
        <VuePerfectScrollbar class="scroll-area--data-list-add-new" :settings="settings">
            <div class="p-6">
              <div class="vx-row p-4">
                <vs-radio v-model="model.type" vs-name="type" class="mr-3" vs-value="personal">Personal</vs-radio>
                <vs-radio v-model="model.type" vs-name="type" vs-value="organization">Organization</vs-radio>
              </div>


              <!-- COMPANY/RECEPTOR -->
              <vs-input label="Name" v-model="model.name" class="mt-5 w-full" name="name"
                        v-validate="{required:true}"/>
              <span class="text-danger text-sm"
                    v-show="errors.has('name')">{{ errors.first('name') }}</span>

              <!-- COMPANY/RECEPTOR -->
              <vs-input label="Organization" v-model="model.company" class="mt-5 w-full" name="company"
                        v-if="model.type == 'organization'"/>
              <span class="text-danger text-sm"
                    v-show="errors.has('company')">{{ errors.first('company') }}</span>

                <!-- PROVINCE -->
                <vs-input label="Province" v-model="model.province" class="mt-5 w-full" name="province"
                          v-validate="'required'"/>
                <span class="text-danger text-sm"
                      v-show="errors.has('province')">{{ errors.first('province') }}</span>

                <!-- CITY -->
                <vs-input label="City" v-model="model.city" class="mt-5 w-full" name="city" v-validate="'required'"/>
                <span class="text-danger text-sm"
                      v-show="errors.has('city')">{{ errors.first('city') }}</span>

                <!-- ADDRESS -->
                <vs-textarea label="Complete address" v-model="model.address" class="mt-5 w-full" name="address"
                             v-validate="{required:true}"/>
                <span class="text-danger text-sm"
                      v-show="errors.has('address')">{{ errors.first('address') }}</span>


                <!-- ZIP -->
                <vs-input label="Post code" v-model="model.zip" class="mt-5 w-full" name="zip"
                          v-validate="{required:true}"/>
                <span class="text-danger text-sm"
                      v-show="errors.has('zip')">{{ errors.first('zip') }}</span>


                <!-- Email -->
                <vs-input label="Email" v-model="model.email" class="mt-5 w-full" name="email"
                          v-validate="{required:true,email:true}"/>
                <span class="text-danger text-sm"
                      v-show="errors.has('email')">{{ errors.first('email') }}</span>



                <!-- PHONE -->
                <vs-input
                        icon-pack="feather"
                        icon="icon-phone"
                        label="Phone"
                        v-model="model.phone"
                        class="mt-5 w-full"
                        v-validate="{ required: true, regex: /\d+(\.\d+)?$/ }"
                        name="phone"/>
                <span class="text-danger text-sm"
                      v-show="errors.has('phone')">{{ errors.first('phone') }}</span>
            </div>
        </VuePerfectScrollbar>

        <div class="flex flex-wrap items-center p-6" slot="footer">
            <vs-button class="ltr:mr-6 rtl:ml-6" @click="submitData" :disabled="!isFormValid">
                <span v-if="Object.entries(this.data).length < 2">Save</span>
                <span v-if="Object.entries(this.data).length > 1">Edit</span>
            </vs-button>
            <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">Cancel</vs-button>
        </div>
    </vs-sidebar>
</template>

<script>
    import VuePerfectScrollbar from 'vue-perfect-scrollbar'

    export default {
        props: {
            isSidebarActive: {
                type: Boolean,
                required: true
            },
            data: {
                type: Object,
                default: () => {
                },
            }
        },
        watch: {
            isSidebarActive(val) {
                if (!val) return
                if (Object.entries(this.data).length < 2) {
                    this.$validator.reset()
                    this.model = this.data;
                } else {
                    this.model = this.data;
                }
                // Object.entries(this.data).length === 0 ? this.initValues() : { this.dataId, this.dataName, this.dataCategory, this.dataOrder_status, this.dataice } = JSON.parse(JSON.stringify(this.data))
            }
        },
        data() {
            return {
                model:{},
                settings: { // perfectscrollbar settings
                    maxScrollbarLength: 60,
                    wheelSpeed: .60,
                },
            }
        },
        computed: {
            isSidebarActiveLocal: {
                get() {
                    return this.isSidebarActive
                },
                set(val) {
                    if (!val) {
                        this.$emit('closeSidebar')
                        this.$validator.reset()
                    }
                }
            },
            isFormValid() {
                return !this.errors.any()
            }
        },
        methods: {
            submitData() {


                this.$validator.validateAll().then(result => {
                    if (result) {
                      this.$vs.loading();

                      // const obj = {
                        //     id: this.dataId,
                        //     name: this.dataName,
                        //     img: this.dataImg,
                        //     category: this.dataCategory,
                        //     order_status: this.dataOrder_status,
                        //     price: this.dataPrice
                        // }
                      this.$store.dispatch("address/addItem", this.model)
                        .then(() => {
                          this.$vs.loading.close();
                        })
                        .catch(() => {
                          this.$vs.loading.close();
                          this.$vs.notify({
                            title: 'خطا در ثبت اطلاعات',
                            text: 'در روند ثبت اطلاعات خطایی رخ داده است',
                            color: 'danger',
                            position:'bottom-left',
                            icon: 'close'
                          })
                        });


                      // if (this.dataId !== null && this.dataId >= 0) {
                        //     this.$store.dispatch("address/addItem", obj).catch(err => {
                        //         console.error(err)
                        //     })
                        // } else {
                        //     delete obj.id
                        //     obj.popularity = 0
                        //     this.$store.dispatch("dataList/addItem", obj).catch(err => {
                        //         console.error(err)
                        //     })
                        // }

                        this.$emit('closeSidebar')
                        this.initValues()
                    }
                })
            },
            updateCurrImg(input) {
                if (input.target.files && input.target.files[0]) {
                    var reader = new FileReader()
                    reader.onload = e => {
                        this.dataImg = e.target.result
                    }
                    reader.readAsDataURL(input.target.files[0])
                }
            }
        },
        components: {
            VuePerfectScrollbar,
        }
    }
</script>

<style lang="scss" scoped>
    .add-new-data-sidebar {
        ::v-deep .vs-sidebar--background {
            z-index: 52010;
        }

        ::v-deep .vs-sidebar {
            z-index: 52010;
            width: 400px;
            max-width: 90vw;

            .img-upload {
                margin-top: 2rem;

                .con-img-upload {
                    padding: 0;
                }

                .con-input-upload {
                    width: 100%;
                    margin: 0;
                }
            }
        }
    }

    .scroll-area--data-list-add-new {
        height: calc(100% - 4.3rem);
    }
</style>
